import {
    ACCOUNT_ROLE_TREATMENTS,
    HIGH_CONTRAST_ACCOUNT_ROLE_TREATMENT,
    normalizeAccountRole,
} from '%evp_theme/brandbook/account/accountMenu';
import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';

function accountRoleTreatment(role, theme) {
    if (isHighContrastTheme(theme)) {
        return HIGH_CONTRAST_ACCOUNT_ROLE_TREATMENT;
    }

    return ACCOUNT_ROLE_TREATMENTS[normalizeAccountRole(role)];
}

export default accountRoleTreatment;
